import { MenuIcon } from './icons';

export default function MobileTopBar({ onOpenSidebar }) {
  return (
    <header className="topbar">
      <button className="hamburger" aria-label="Open menu" onClick={onOpenSidebar}>
        <MenuIcon />
      </button>
      <div className="brand-name" style={{ fontSize: 16 }}>ARMAGEDIFY</div>
      <div style={{ width: 40 }} />
    </header>
  );
}
